import './imageBlock.scss';

import { GatsbyImage } from 'gatsby-plugin-image';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import rightArrowIcon from '../../images/englander-icons/Right-Arrow-Icon.svg';

interface IButtonBlock {
    title: string;
    onClick: () => void;
    hasArrow?: boolean;
}

export default function ImageBlock(props: {
    title: string;
    image: IGatsbyImageData;
    content?: string;
    contentMarkdown?: string;
    button?: IButtonBlock;
    children?: any;
    imageTitleTop?: string;
    imageTitleBottom?: string;
    className?: string;    
}) {
    const {
        content,
        contentMarkdown,
        image,
        title,
        button,
        children,
        imageTitleTop,
        imageTitleBottom,
        className = '',
    } = props;

    return (
        <div
            className={`englander-image-block-container ${
                className ? className : ''
            }`}
        >
            <div className='image-block-wrapper'>
                {image ? (
                    <>
                        <GatsbyImage
                            className='block-image'
                            image={image}
                            alt=''
                        />
                        {(imageTitleBottom || imageTitleTop) && (
                            <div className='title-overlay'>
                                {imageTitleTop && (
                                    <span className='img-title-top'>
                                        {imageTitleTop}
                                    </span>
                                )}
                                {imageTitleBottom && (
                                    <span className='img-title-bottom'>
                                        {imageTitleBottom}
                                    </span>
                                )}
                            </div>
                        )}
                    </>
                ) : (
                    <div className='block-image no-image'></div>
                )}
                <div className={`block-content ${!image ? `no-image` : ''}`}>
                    <div className='block-title'>{title}</div>
                    {content && <div className='block-text'>{content}</div>}
                    {contentMarkdown && (
                        <div
                            className='block-text'
                            dangerouslySetInnerHTML={{
                                __html: contentMarkdown,
                            }}
                        />
                    )}
                    {children}
                    {button && (
                        <button
                            className='block-button'
                            onClick={button.onClick}
                        >
                            {button.title}
                            {button.hasArrow && (
                                <img src={rightArrowIcon} alt=''></img>
                            )}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
